// _____ADDED for development only *RESPONSE project*
//imports global setup for ip usage
import {ip_setup} from "../../../globals";
import {chat_setup} from "../../../globals";




// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // backendUrlPort: 'http://'+ ip_setup +':3005',
  // backendChatUrlPort: 'http://'+ ip_setup +':5555' 

  // backendUrlPort: 'https://openinnovationchallenges.h2020response.eu/services',
  // backendChatUrlPort: 'https://openinnovationchallenges.h2020response.eu/chat'
  
  // backendUrlPort: 'http://localhost:3005',
  // backendChatUrlPort: 'http://localhost:5555'


  backendUrlPort: ip_setup,
  backendChatUrlPort: chat_setup

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
